import { GET_ORGANIZATION_LOGIN } from "../../types";
import createAsyncActions from "../../../../utilities/createAsyncActions";
export const {
  getOrganizationLogin,
  getOrganizationLoginPending,
  getOrganizationLoginFulfilled,
  getOrganizationLoginRejected,
} = createAsyncActions(GET_ORGANIZATION_LOGIN, "getOrganizationLogin");



// WEBPACK FOOTER //
// ./src/features/organization/actions/getActions/getOrganizationLoginActions.js